import { useTranslation } from "@msuite/ui/localization";
import { type AsyncModalController, ConfirmModal } from "@msuite/ui/modal";

/** Props Interface */
interface SubstitutionPlanCopyPreviousModalProps {
	controller: AsyncModalController<boolean>;
}

export function SubstitutionPlanCopyPreviousModal({
	controller,
}: SubstitutionPlanCopyPreviousModalProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<ConfirmModal
			controller={controller}
			message={t("substitutions.copy_previous_plan_message")}
			confirmLabel={t("substitutions.copy_previous_plan_confirm")}
			rejectLabel={t("substitutions.copy_previous_plan_reject")}
			confirmVariant="accent"
			data-cy="substitution-plan-copy-previous-modal"
		/>
	);
}
